import React from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';
import { Map } from 'immutable';
import styles from './style.scss';

const propTypes = {
  event: PropTypes.instanceOf(Map).isRequired,
  className: PropTypes.string,
  disableLink: PropTypes.bool,
};

function Title({ event, className = '', disableLink = false }) {
  return (
    <div className={cn(styles.title, className, 'title')}>
      {!disableLink ? (
        <a href={event.get('url')} target="_blank" rel="noopener noreferrer">
          {event.get('title')}
        </a>
      ) : (
        <span className={cn(styles.title, className, 'title')}>{event.get('title')}</span>
      )}
    </div>
  );
}

Title.propTypes = propTypes;

export default Title;



// WEBPACK FOOTER //
// ./src/widget/event_components/title.js